

function ImageIcon({mimetype}:{mimetype:string|undefined}){
        if(!mimetype){
            return '';
        }
        if (mimetype=='image/svg+xml') return (<i className="bi bi-filetype-svg"></i>)
        if (mimetype=='application/pdf') return (<i className="bi bi-filetype-pdf"></i>)
        if (mimetype=='image/png') return (<i className="bi bi-filetype-png"></i>)
        if (mimetype=='image/jpg') return (<i className="bi bi-filetype-jpg"></i>)
        return '';
            
}
export default ImageIcon;